<div class="overlaySpinner" *ngIf="loading">
    <mat-progress-spinner class="querySpinner" color="accent" mode="indeterminate"></mat-progress-spinner>
</div>
<app-spinner></app-spinner>
<router-outlet></router-outlet>